import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function ScrollToTop() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    // If URL has a hash (e.g. #event-inquiry), scroll to that element instead of top.
    if (hash) {
      // Defer to next frame so the target element is in the DOM.
      const attempt = (tries = 0) => {
        const el = document.getElementById(hash.replace('#', ''))
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        } else if (tries < 10) {
          // Retry briefly while the route's content mounts.
          setTimeout(() => attempt(tries + 1), 80)
        } else {
          window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior })
        }
      }
      attempt()
      return
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior })
  }, [pathname, hash])

  return null
}
